export default "__VITE_ASSET__b251a590__"